module.exports = __webpack_public_path__ + "static/röver-ea2226fbfa9fb2780686d523d88be983.jpg";